// extracted by css-extract-rspack-plugin
export default {"pageHeader":"e9xRz3HwQrT5mdXUyi_fH"};